import * as React from "react";

export interface ControlButtonsProps {
  className?: string;
  onPrevClick?: () => void;
  onNextClick?: ()=>void;
  currentIndex?: number;
  isLastPage?: boolean;
  isFirstPage?: boolean;
}

export interface ControlButtonsState {}

export class ControlButtons extends React.Component<
  ControlButtonsProps,
  ControlButtonsState
> {
  el: HTMLDivElement;
  constructor(p: ControlButtonsProps) {
    super(p);
  }

  render() {
    let props = this.props,
      state = this.state,
      cls = this.props.className || "";
    return (
      <div className={"control-buttons " + cls} ref={e => (this.el = e)}>
        <div className={"control-buttons__controls " + cls}>
          {!props.isFirstPage &&
          <div onClick={props.onPrevClick} className="control-buttons__control-button control-buttons__control-button--left">
            <i className="icon-ip-ccslider-left" />
          </div>
          }
          {!props.isLastPage &&
          <div onClick={props.onNextClick}className="control-buttons__control-button control-buttons__control-button--right">
            <i className="icon-ip-ccslider-right" />
          </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/ControlButtons/ControlButtons.tsx